/** Wrap evaluation dashboard KPI strips so alert label ink meets AA on tinted cards. */
export const EVAL_DASHBOARD_KPI_A11Y_CLASS = "eval-dashboard-kpi-a11y"

/** KPI strip sits flush under PageHeader — parent supplies horizontal inset. */
export const EVAL_DASHBOARD_KPI_STRIP_CLASS = "px-0 py-0 lg:px-0"
